import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'
import { Popover as MuiPopover } from '@material-ui/core'

export const PulseSurveysWrapper = styled.div`
    margin-top: auto;
    padding: 15px;

    button {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`

export const Popover = styled(MuiPopover)`
    .MuiPopover-paper {
        width: 226px;
        padding: 0;
        box-shadow: none;
        background-color: transparent;
    }
`

export const PulseSurveys = styled.section`
    display: flex;
    padding: 4px 8px 8px 8px;
    margin-bottom: 15px;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 12px;
    background-color: ${({ theme }) => theme.colors.primary60};
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
    color: ${({ theme }) => theme.colors.primaryWhite};
`

export const PulseSurveysTitle = styled.h3`
    padding: 10px;

    ${getFontStyle('p03Semibold')}
`

export const PulseSurveysList = styled.ul`
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
`

export const PulseSurveysListItem = styled.li`
    display: flex;
    padding: 12px 10px 14px 10px;
    flex-direction: column;
    gap: 4px;
    border-radius: 10px;
    cursor: pointer;

    &:hover {
        background-color: ${({ theme }) => theme.colors.primary50};
    }
`

export const PulseSurveysListItemHeader = styled.header`
    display: flex;
    align-items: center;
    gap: 6px;

    ${getFontStyle('p02Semibold')}
`

export const PulseSurveysListItemDescription = styled.p`
    margin: 0;

    ${getFontStyle('p03Regular')}
`
